


class RecentlyJoinedResponse {
    constructor(userId,userNum, name,gender, age, height, qualification,educationCategory,occupation, caste, religion, city, state, country, isPaidUser, is_Shortlist,isShortListed,
        profilePath, isPaid,lookUpId,themeColour,themeColourText,themeColourNumber) 
        {
        this.userId = userId;
        this.userNum = userNum;
        this.name = name;
        this.gender = gender;
        this.age = age;
        this.height = height;
        this.qualification = qualification;
        this.educationCategory = educationCategory;
        this.occupation = occupation;
        this.religion = religion;
        this.city = city;
        this.state = state;
        this.caste = caste;
        this.country = country;
        this.isPaidUser = isPaidUser;
        this.is_Shortlist = is_Shortlist;
        this.isShortListed=isShortListed;
        this.profilePath = profilePath;
        this.isPaid = isPaid;
        this.lookUpId = lookUpId;
        this.themeColour = themeColour;
        this.themeColourText = themeColourText;
        this.themeColourNumber = themeColourNumber;

       

    }
    static fromJson(json) {
        return new RecentlyJoinedResponse(
            json.userId,
            json.userNum,
            json.name,
            json.gender,
            json.age,
            json.height,
            json.qualification,
            json.educationCategory,
            json.occupation,
            json.caste,
            json.religion,
            json.city,
            json.state,
            json.country,
            json.isPaidUser,
            json.is_Shortlist,
            json.isShortListed,
            json.profilePath,
            json.isPaid,
            json.lookUpId,
            json.themeColour,
            json.themeColourText,
            json.themeColourNumber

           
        );
    }
}
export default RecentlyJoinedResponse;